import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalculateCoverResponse } from 'src/app/models/calculate-cover-response';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-cover-results',
  templateUrl: './cover-results.component.html',
  styleUrls: ['./cover-results.component.scss'],
})
export class CoverResultsComponent implements OnInit {

  @Input() questionnaire: QQQuestionnaireViewModel;

  answers: any;
  coverTypeDisplay: any;
  resultCoverTypeDisplay: any;
  childAges: number[];
  loading: boolean;

  @Output() next = new EventEmitter<CalculateCoverResponse>;

  result: CalculateCoverResponse;

  constructor(
    private api: ApiService
  ) { }

  async ngOnInit() {
    this.loading = true;
    this.answers = this.questionnaire.answersObject;
    this.childAges = this.answers['ChildrenAges']?.split(',');

    try {
    let coverType = this.answers['CoverType']
    let mortgageType = this.answers['MortgageType']
    this.coverTypeDisplay = coverType == 'Income' ? 'Family & Income' : 'Mortgage';
    this.result = await this.api.calculateCover({
      coverType: coverType,
      mortgageType: mortgageType,
      mortgageAmount: toNumber(this.answers.MortgageAmount),
      mortgageTerm: toNumber(this.answers.MortgageTerm),
      monthlyIncome: toNumber(this.answers.MonthlyIncome),
      incomeTerm: toNumber(this.answers.IncomeYears),
      currentAge: toNumber(this.answers.Age),
      retirementAge: toNumber(this.answers.RetirementAge),
      childrenAges: this.getChildrenAges(this.answers.ChildrenAges),
      universityCover: this.answers.UniversityCover === 'Y'
    });

    this.resultCoverTypeDisplay = this.result.coverBasis == 'LEVEL' ? 'Level Term Assurance ' : 'Decreasing Term Assurance ';
    
    }
    catch (err: any) {
    }
    finally {
      this.loading = false;
    }

  }

  back() {
    this.questionnaire.back();
  }

  private getChildrenAges(source: string): number[] {
    if (!source)
      return [];

    return source.split(',')?.map(x => toNumber(x));
  }
}

function toNumber(source: string) {
  return parseInt(source) || 0;
}
